import type { ReactNode } from "react";

import { useAuthStore } from "../auth-store";
import { parseRole } from "../rbac/permissions";
import { type KvStore, ZeroProvider } from "../zero";
import { ZeroEventHandlers } from "./zero-event-handlers";

export interface AuthenticatedZeroProviderProps {
  children: ReactNode;
  zeroUrl: string;
  kvStore?: KvStore;
  renderLoading?: () => ReactNode;
}

export function AuthenticatedZeroProvider({
  children,
  zeroUrl,
  kvStore,
  renderLoading,
}: AuthenticatedZeroProviderProps): ReactNode {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const isInitializing = useAuthStore((s) => s.isInitializing);

  if (isInitializing || !user) {
    return renderLoading ? renderLoading() : null;
  }

  const role = parseRole(user.role);

  return (
    <ZeroProvider
      {...(token && { auth: token })}
      kvStore={kvStore}
      role={role}
      serverUrl={zeroUrl}
      userID={user.id}
    >
      <ZeroEventHandlers kvStore={kvStore} />
      {children}
    </ZeroProvider>
  );
}
